import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentUser: {
        name: "Noémie Henry",
        role: "invité",
        avatar: "/avatars/librarian.png",
        code_etablissement: "ESHS1",
        token: "LeToken",
        isLoggedIn: false
    },
    //apiBase: "http://localhost:3004",
    apiBase: "https://biblius.ch",
    delaiEmprunt: 2, // Délai d'emprunt en jours
    isbndbApiKey: "key",
    lateReturnEmailTemplate: localStorage.getItem('late-return-email-template') || "Bonjour {name},\n\nLe livre '{title}' que vous avez emprunté est en retard. Merci de le rapporter à la bibliothèque dès que possible.\n\nCordialement,\nL'équipe Biblius",
    libraryAddress: localStorage.getItem('library-address'),
    libraryEmail: localStorage.getItem('library-email'),
    libraryPhone: localStorage.getItem('library-phone'),
    libraryHours: localStorage.getItem('library-hours') || JSON.stringify([
        { days: "Lundi", hours: "Fermé" },
        { days: "Mardi", hours: "10h00 - 18h00" },
        { days: "Mercredi", hours: "10h00 - 19h00" },
        { days: "Jeudi", hours: "14h00 - 18h00" },
        { days: "Vendredi", hours: "10h00 - 18h00" },
        { days: "Samedi", hours: "10h00 - 17h00" },
        { days: "Dimanche", hours: "Fermé" },
    ]),
    libraryLogo: "",
    enableReservation: true
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.currentUser = action.payload;
            state.libraryLogo = "/uploads/logos/logo_" + action.payload.code_etablissement + ".png";
        },
        setSettings: (state, action) => {
            if (action.payload.delaiEmprunt) {
                state.delaiEmprunt = parseInt(action.payload.delaiEmprunt);
            }
            if (action.payload.lateReturnEmailTemplate) {
                state.lateReturnEmailTemplate = action.payload.lateReturnEmailTemplate;
            }
            if (action.payload.libraryAddress) state.libraryAddress = action.payload.libraryAddress;
            if (action.payload.libraryEmail) state.libraryEmail = action.payload.libraryEmail;
            if (action.payload.libraryPhone) state.libraryPhone = action.payload.libraryPhone;
            if (action.payload.libraryHours) state.libraryHours = action.payload.libraryHours;
            //if (action.payload.libraryLogo) state.libraryLogo = action.payload.libraryLogo;
        },
        setIsLoggedIn: (state, action) => {
            state.currentUser.isLoggedIn = action.payload;
        },
        setMailTemplate: (state, action) => {
            state.lateReturnEmailTemplate = action.payload;
            localStorage.setItem('late-return-email-template', action.payload);
        },
        updateSettings: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
});

export const { setUser, setIsLoggedIn, setMailTemplate, updateSettings, setSettings } = userSlice.actions;
export default userSlice.reducer;
